@if (!customDropdown()) {
  @if (formControl; as control) {
    <div
      class="container korviu-select-container"
      [class.medium]="size() === 'medium'"
      [class.large]="size() === 'large'"
      [class.disabled]="isDisabled"
    >
      <nz-form-item
        class="industry-form-item korviu-input-box"
        [ngClass]="{
          active: hasValue || open,
          filled: isFilled,
          'error-input': isInvalid
        }"
      >
        @if (fieldIsClearOrValid(control) && label()) {
          <label
            class="paragraph-medium regular korviu-input-label"
            [ngClass]="{
              'error-text': showErrorMessagesUnderField() && isInvalid
            }"
          >
            {{ label() }}
          </label>
        }

        @if (!showErrorMessagesUnderField() && control.dirty && firstInputError?.['required']) {
          <label class="paragraph-medium regular error-text korviu-input-label">
            {{ 'validation.required' | translate }}
          </label>
        }

        <nz-select
          nzSize="large"
          class="korviu-input"
          [formControl]="control"
          [nzCustomTemplate]="suffixType() === 'country-flag-async' ? countryTemplate : null"
          [nzDisabled]="isDisabled"
          [nzPlaceHolder]="resolvedPlaceholder"
          [nzSuffixIcon]="selectSuffixIcon"
          [(nzOpen)]="open"
        >
          @for (option of options(); track option.id) {
            <nz-option
              [nzLabel]="option.localizable_name ? (option.localizable_name | translate) : option.value"
              [nzValue]="option.id"
            ></nz-option>
          }
        </nz-select>
      </nz-form-item>

      @if (showErrorMessagesUnderField() && control.dirty && control.hasError('required')) {
        <div class="under-field-error-messages">
          <span class="error-text"> {{ 'auth.signup.pleaseEnterYour' | translate }}{{ label() }} </span>
        </div>
      }
    </div>
  }
}

@if (customDropdown()) {
  <div
    class="container korviu-select-container korviu-select-container--custom"
    [class.medium]="size() === 'medium'"
    [class.large]="size() === 'large'"
    [class.disabled]="isDisabled"
  >
    <nz-form-item
      class="industry-form-item korviu-input-box"
      [ngClass]="{
        disabled: isDisabled,
        active: hasValue || open,
        filled: isFilled,
        'has-prefix': !!prefixType()
      }"
    >
      @if (label()) {
        <label class="paragraph-medium regular korviu-input-label">{{ label() }}</label>
      }

      <nz-select
        nzSize="large"
        class="korviu-input"
        nzDropdownClassName="korviu-custom-dropdown"
        [nzCustomTemplate]="suffixType() === 'country-flag-async' ? countryTemplate : null"
        [nzDisabled]="isDisabled"
        [nzDropdownMatchSelectWidth]="false"
        [nzDropdownRender]="customDropdownTemplate"
        [nzPlaceHolder]="resolvedPlaceholder"
        [nzPlacement]="'bottomLeft'"
        [nzSuffixIcon]="selectSuffixIcon"
        [(nzOpen)]="open"
      ></nz-select>

      @switch (prefixType()) {
        @case ('sort') {
          <i nz-icon class="prefix" aria-hidden="true">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path
                d="M14.3758 3.3335L14.2909 3.33921C13.9858 3.38059 13.7508 3.64208 13.7508 3.9585L13.75 14.5352L11.0668 11.8538L10.9967 11.7933C10.7519 11.6119 10.4047 11.6322 10.1828 11.8542C9.93892 12.0984 9.93909 12.4941 10.1833 12.7381L13.9364 16.4881L14.0065 16.5486C14.2513 16.73 14.5985 16.7097 14.8203 16.4877L18.5672 12.7377L18.6276 12.6676C18.8091 12.4228 18.7888 12.0756 18.5668 11.8538L18.4967 11.7933C18.2519 11.6119 17.9047 11.6322 17.6828 11.8542L15 14.5385L15.0008 3.9585L14.995 3.87369C14.9537 3.56862 14.6922 3.3335 14.3758 3.3335ZM5.17868 3.51657L1.43304 7.26245L1.37253 7.33255C1.19099 7.57723 1.21118 7.92445 1.43308 8.14633L1.50318 8.20685C1.74786 8.38841 2.09508 8.36816 2.31696 8.14631L4.9975 5.46442L4.99805 16.0459L5.00376 16.1307C5.04514 16.4358 5.30664 16.6709 5.62305 16.6709L5.70786 16.6652C6.01293 16.6238 6.24805 16.3623 6.24805 16.0459L6.2475 5.46609L8.93325 8.1468L9.00342 8.20724C9.24825 8.3885 9.59542 8.368 9.81709 8.14584C10.0609 7.9015 10.0605 7.50576 9.81617 7.26196L6.06209 3.51607L5.99198 3.45567C5.7473 3.2745 5.40039 3.29484 5.17868 3.51657Z"
                fill="currentColor"
              />
            </svg>
          </i>
        }
        @case ('filter') {
          <i nz-icon class="prefix" aria-hidden="true">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path
                d="M11.25 13.3333C11.5952 13.3333 11.875 13.6132 11.875 13.9583C11.875 14.3035 11.5952 14.5833 11.25 14.5833H8.75C8.40483 14.5833 8.125 14.3035 8.125 13.9583C8.125 13.6132 8.40483 13.3333 8.75 13.3333H11.25ZM13.75 9.16667C14.0952 9.16667 14.375 9.4465 14.375 9.79167C14.375 10.1368 14.0952 10.4167 13.75 10.4167H6.25C5.90482 10.4167 5.625 10.1368 5.625 9.79167C5.625 9.4465 5.90482 9.16667 6.25 9.16667H13.75ZM16.25 5C16.5952 5 16.875 5.27983 16.875 5.625C16.875 5.97017 16.5952 6.25 16.25 6.25H3.75C3.40483 6.25 3.125 5.97017 3.125 5.625C3.125 5.27983 3.40483 5 3.75 5H16.25Z"
                fill="currentColor"
              />
            </svg>
          </i>
        }
      }

      <ng-template #customDropdownTemplate>
        <ng-content></ng-content>
      </ng-template>
    </nz-form-item>
  </div>
}

<ng-template #countryTemplate let-selectedCountry>
  <div class="custom-select-template">
    @if (getCountryFlagLink(selectedCountry.nzValue); as flagLink) {
      <img [src]="flagLink" alt="" class="country-flag-icon" />
    }
    <span>{{ selectedCountry.nzLabel }}</span>
  </div>
</ng-template>

<ng-template #selectSuffixIcon>
  <span class="korviu-select-arrow" aria-hidden="true"></span>
</ng-template>
